import { defaultBrand, deriveScale } from '../tokens';
import { LEGACY_COLOR_KEYS, LEGACY_RADIUS } from './eski-anahtarlar';
import { webRadius, webShadow } from './olcekler';
import { webDesignDark, webDesignLight } from './renkler';
export * from './renkler';
export * from './olcekler';
export * from './eski-anahtarlar';
export * from './logo';
export * from './yerlesim';
const designByMode = {
    light: webDesignLight,
    dark: webDesignDark,
};
/** Tasarımın varsayılan mor tonu; env bu tondan farklı bir `primary` verirse rampa türetilir. */
export const WEB_DESIGN_PRIMARY = webDesignLight.primary;
/**
 * "MARKA VERİLMEDİ" ÖLÇÜTÜ (renk ailesi L20, tech-lead 30.10.2026): env'in
 * birincil tonu platformun KOD VARSAYILANINA (`defaultBrand.primary`) eşitse
 * env bir marka seçmemiş, yalnız varsayılanı tekrarlamıştır. Ölçüt bir hex
 * sabiti değil, varsayılanın kendisidir: `brandFromEnv` env boşken de aynı
 * değeri döndürür, yani "env yok" ile "env varsayılanı yazıyor" aynı sonuca
 * düşer. Varsayılan mobilin donmuş temasıyla eski petroldedir ve API ile mobil
 * zinciri env'i okuduğu için env değiştirilmez; web varsayılan markada
 * tasarımla birebir kalır. Başka bir ton yine rampa kurar.
 *
 * Etkinlik markası ayrı yoldan gelir (sunucunun çözdüğü etkinlik/kurum
 * zinciri): orada ölçüt zincirin kaynağıdır (platform halkası = marka yok), hex
 * karşılaştırması yapılmaz (`apps/web/src/shared/theme/brand-color-vars.ts`).
 */
const DEFAULT_PRIMARIES = new Set([WEB_DESIGN_PRIMARY, defaultBrand.primary].map((tone) => tone.toUpperCase()));
/**
 * Renk kümesi. VURGU ENV'DEN ALINMAZ (K5): web, e-posta ve PDF bu rengi
 * tasarımdan alır (`BRAND_ACCENT` yalnız mobilin donmuş zinciri için kalır),
 * çünkü env'deki eski kiremit (#B4551F) fıstığı ezer ve düğme standardını bozar.
 *
 * Birincil ton env'den gelebilir (`NEXT_PUBLIC_BRAND_PRIMARY`, marka tek kaynak
 * sözleşmesi): ton varsayılanlardan (`DEFAULT_PRIMARIES`) farklıysa birincil
 * aile eski türetme kuralıyla kurulur. Varsayılan markada (bugünkü bütün env
 * dosyaları) hiçbir şey türetilmez ve değerler tasarımla birebir aynıdır.
 */
export function createWebColors(mode, brand) {
    const design = withBrandPrimary(designByMode[mode], mode, brand?.primary);
    const legacy = {};
    for (const [name, row] of Object.entries(LEGACY_COLOR_KEYS)) {
        const source = row.kaynak;
        const from = source.tema
            ? withBrandPrimary(designByMode[source.tema], source.tema, brand?.primary)
            : design;
        legacy[name] = from[source.tasarim];
    }
    return { ...design, ...legacy };
}
/**
 * LOGO İŞARETİNİN RENKLERİ (web, plan K3): koyu mor kare, beyaz W, fıstık onay.
 * Logo kartı: "İşaret yeniden renklendirilmez … Onay işareti her zaman
 * `accent`." İki temada ve bantta AYNI üç renk; değerler açık tema web
 * renklerinden (env'in varsayılan dışı tonu kareyi taşır, vurgu env'den alınmaz,
 * K5). Mobil ikonlar `brandMarkColors`ta kalır (K3).
 */
export function webBrandMarkColors(brand) {
    const light = createWebColors('light', brand);
    return { square: light.primary, mark: light.textOnPrimary, accent: light.accent };
}
/** Moda bağlı gölgeler (`shadow-1` …). Eski `--ib-elevation-*` adları 6a'da emekli oldu. */
export function createWebShadows(mode) {
    return webShadow[mode];
}
/** Eski köşe adlarının px değerleri (kalan `md`, `lg`; `eski-anahtarlar.ts`). */
export function legacyRadiusPx() {
    return resolveScale(LEGACY_RADIUS, webRadius);
}
function resolveScale(table, scale) {
    const out = {};
    for (const [name, row] of Object.entries(table)) {
        out[name] = typeof row.kaynak === 'string' ? scale[row.kaynak] : row.kaynak.sabit;
    }
    return out;
}
function withBrandPrimary(base, mode, primary) {
    if (!primary || DEFAULT_PRIMARIES.has(primary.toUpperCase()))
        return base;
    if (mode === 'light') {
        const scale = deriveScale(primary, 'primary');
        return {
            ...base,
            primary: scale[500],
            primaryHover: scale[600],
            primaryActive: scale[700],
            primarySubtle: scale[100],
            primaryBorder: scale[200],
            primaryStrong: scale[700],
            focusRing: scale[500],
            chart1: scale[500],
        };
    }
    return {
        ...base,
        primary: shade(primary, 0.42),
        primaryHover: shade(primary, 0.58),
        primaryActive: shade(primary, 0.7),
        primarySubtle: shade(primary, -0.66),
        primaryBorder: shade(primary, -0.46),
        primaryStrong: shade(primary, 0.72),
        focusRing: shade(primary, 0.42),
        chart1: shade(primary, 0.42),
    };
}
/** `../tokens.ts`teki türetme ile aynı formül (o dosya mobil için donmuştur, dışa aktarmaz). */
function shade(hex, amount) {
    const value = parseInt(hex.replace('#', ''), 16);
    const channels = [(value >> 16) & 255, (value >> 8) & 255, value & 255].map((channel) => Math.max(0, Math.min(255, Math.round(amount < 0 ? channel * (1 + amount) : channel + (255 - channel) * amount))));
    return `#${channels.map((channel) => channel.toString(16).padStart(2, '0')).join('')}`;
}
//# sourceMappingURL=index.js.map